import { QuotationTask, SalesOrderContractTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1662. 受注案件契約タスク関連書類なし更新
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:id/update_none_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  id: number;
  none_documents: boolean;
};

const updateNoneDocuments = (props: Props): Promise<SalesOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.id}/update_none_documents`,
    props
  );
};

export const useUpdateNoneDocuments = () => {
  return useMutation({
    mutationFn: updateNoneDocuments,
  });
};
